// extracted by mini-css-extract-plugin
module.exports = {"navbar":"styles_navbar__2eF_q","menuIcon":"styles_menuIcon__ai1Me"};